import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import NotFound from 'yoda-app-shell/lib/components/NotFound/NotFound';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import Coupon from './containers/Pages/Coupon/Coupon';

export default function App() {
    return (
        <Layout>
            <Switch>
                <Route path="/m/jcpenney-coupons/N-mpi6e5" component={Coupon} />
                <Route path="/m/jcpenney-coupons" component={Coupon} />
                <Redirect from="/coupon" to="m/jcpenney-coupons/N-mpi6e5" />
                <Redirect from="/coupons" to="m/jcpenney-coupons/N-mpi6e5" />
                <Redirect from="/qa*-coupon" to="m/jcpenney-coupons/N-mpi6e5" />
                <Redirect from="/m(/:pname)/N-mpi6e5(\\*)" to="m/jcpenney-coupons/N-mpi6e5(\\*)" />
                <Redirect from="/m/:pname(/)" to="m/jcpenney-coupons/N-mpi6e5" />
                <Route path="/*" component={Coupon} />
                {/* when none of the above match, <NoMatch> will be rendered */}
                <Route component={NotFound} />
            </Switch>
        </Layout>
    );
}
